import "./insKpiDatapointWidget.scss";
import React, { useMemo, useRef } from "react";
import { InsWidget, InsWidgetTitle } from "../../base";
import { InsQueryStatedElement } from "../../base/insQueryStatedElement";
import { KpiContent } from "./kpiContent";
import { InsChartSelector } from "components/widgets/chart/base/insChartSelector";
import { InsChartSettings } from "components/widgets/chart/base/insChartSettings";
import { getShortLabelForTenor } from "components/widgets/chart/base/utils";
import { getDateString } from "common/date-utils";
import { useIsTenorSettingsAvailable, useIsTimePeriodAvailable, useResolvedCustomDateRangeEndDate, useResolvedCustomDateRangeStartDate, useResolvedTenor, useWidgetComponentProps } from "components/widgets/hooks/use-current-widget";
import { useGetDatapointsWidgetData } from "hooks/widget-data/use-datapoints";
import { ChartSelectSlotProps, TenorOptions } from "store/current-dashboard/types";
const useTenorDisplayText = (tenor, customStartDate, customEndDate) => {
    const prevTenorDisplayRef = useRef(undefined);
    return useMemo(() => {
        if (tenor === TenorOptions.customDateRange) {
            if (customStartDate && customEndDate) {
                const text = `${getDateString(customStartDate)} - ${getDateString(customEndDate)}`;
                prevTenorDisplayRef.current = text;
                return text;
            }
            return prevTenorDisplayRef.current ?? getShortLabelForTenor(tenor);
        }
        const text = getShortLabelForTenor(tenor);
        prevTenorDisplayRef.current = text;
        return text;
    }, [customEndDate, customStartDate, tenor]);
};
const getHeaderLeft = (hasSelector, props, tenorDisplayText, widgetSubtitle) => {
    if (hasSelector) {
        return React.createElement(InsChartSelector, { index: 0, widgetId: props.widgetId, sectionId: props.sectionId, slot: ChartSelectSlotProps.left });
    }
    return tenorDisplayText || widgetSubtitle || " ";
};
const getResultData = (result) => {
    const [data] = result?.[0]?.data || [];
    if (data) {
        data.additionalData = result?.[0]?.additionalData;
    }
    return data;
};
const hasKpiData = (data) => Boolean((data?.value?.value && data.value.value !== "NaN") || data?.value?.value === 0);
export const InsKpiDatapointWidget = (props) => {
    const { sectionId, widgetId, index, groupId } = props, widgetProps = useWidgetComponentProps(sectionId, widgetId);
    const [result, queryState] = useGetDatapointsWidgetData(props);
    const isTimePeriodAvailable = useIsTimePeriodAvailable(sectionId, widgetId);
    const isTenorSettingsAvailable = useIsTenorSettingsAvailable(sectionId, widgetId);
    const tenor = useResolvedTenor(sectionId, widgetId);
    const customStartDate = useResolvedCustomDateRangeStartDate(sectionId, widgetId);
    const customEndDate = useResolvedCustomDateRangeEndDate(sectionId, widgetId);
    const tenorDisplayText = useTenorDisplayText(tenor, customStartDate, customEndDate);
    const data = getResultData(result);
    const hasSelector = Boolean(widgetProps?.dataSelectProps && widgetProps?.dataSelectProps?.length > 0);
    return React.createElement("div", { className: `ins-kpi-widget ${widgetProps?.dataSelectProps && "ins-kpi-widget-select-header"}` },
        React.createElement(InsWidget, { sectionId: sectionId, widgetId: widgetId, content: React.createElement(InsQueryStatedElement, { widgetFactoryProps: { sectionId, widgetId }, queryState: queryState, hasData: hasKpiData(data) },
                React.createElement(KpiContent, { ...props, data: data, sparklineType: widgetProps.sparkline, variationOptions: widgetProps.variationOfMetric, format: widgetProps.valueFormat })), headerLeft: getHeaderLeft(hasSelector, props, tenorDisplayText, widgetProps.subtitle), settingsContent: isTimePeriodAvailable || isTenorSettingsAvailable ? React.createElement(InsChartSettings, { ...props }) : undefined, title: React.createElement(InsWidgetTitle, { sectionId: sectionId, widgetId: widgetId, index: index, groupId: groupId }) }));
};
